module.exports = __webpack_public_path__ + "img/step1.9267dfa2.png";